export default {
  message: 'Message diffusé',
  logoutWarning: 'Tous les utilisateurs, à l\'exception des administrateurs, seront déconnectés après l\'activation du mode de maintenance',
  maintenanceModeIsOn: 'Le mode maintenance est activé',
};
